import ref from 'services/firebaseRef';
import { setCurrentLevel, advanceLevel, completeLevelAndAdvance } from './sessionActions';
import {publishEvent} from "services/events";
import program from "programs";

export const ACTIVE_SESSION_LOADED = 'ACTIVE_SESSION_LOADED';
export const ACTIVE_SESSION_SET = 'ACTIVE_SESSION_SET';

function getValue(path) {
  return new Promise((resolve) => {
    ref.child(path)
      .once('value', snapshot => {
        resolve(snapshot.val());
      });
  });
}

function activeSessionLoaded (activeSession) {
  return {
    type: ACTIVE_SESSION_LOADED,
    activeSession
  };
}

export function unbindActiveSession (refs) {
  return () => {
    refs.forEach(savedRef => {
      savedRef.off();
    });
  };
}

function activeSessionSet ({ userId, sessionId }) {
  return {
    type: ACTIVE_SESSION_SET,
    userId,
    sessionId
  };
}

export function setActiveSession({ userId, sessionId, level, deviceRole, programId }) {
  return dispatch => {
    let promise;
    if (sessionId === 'none') {
      promise = Promise.resolve(true);
    } else {
      promise = dispatch(
        setCurrentLevel({ sessionId, currentLevel: level })
      );
    }
    return promise.then(() => {
      return new Promise((resolve, reject) => {
        ref.child('users').child(userId).update({
          activeSession: sessionId
        }, error => {
          if (error) {
            reject(error);
          } else {
            resolve();
          }
        });
      });
    }).then(() => {
      if (level !== "prep" && sessionId !== "none") {
        publishEvent('Presentation Started', {
          userId,
          sessionId,
          programId,
          currentLevel: level,
          deviceRole
        });
      } else if (level === "prep") {
        publishEvent('Set Up Presentation Started', {
          userId
        });
      }
      return dispatch(
        activeSessionSet({ userId, sessionId })
      );
    });
  };
}

export function bindActiveSession (userId, refs, pageLoad) {
  return dispatch => {
    const activeSessionRef = ref.child('users').child(userId).child('activeSession');
    let first = true;
    activeSessionRef.on('value', snapshot => {
      const activeSession = snapshot.val();
      if (!first) {
        dispatch(activeSessionLoaded(activeSession));
        return;
      }
      first = false;
      getValue(['sessions', activeSession, 'currentLevel'].join('/'))
        .then(currentLevel => {
          if (pageLoad && currentLevel !== 'prep') {
            dispatch(setActiveSession({userId, sessionId: 'none'}));
            return;
          }
          dispatch(activeSessionLoaded(activeSession));
        });
    });
    refs.push(activeSessionRef);
  };
}

export function completeLevelAndExit({
  userId,
  sessionId,
  programId,
  completedLevel,
  finished,
  contractId,
  funding,
  previousCompletedLevel
}) {
  const action = Number(previousCompletedLevel) === Number(completedLevel) ? advanceLevel : completeLevelAndAdvance;
  return dispatch => {
    return dispatch(
      setActiveSession({ userId, sessionId: 'none' })
    ).then(() => dispatch(
      action({ sessionId, completedLevel, programId, finished, contractId, userId, funding })
    )).then(() => dispatch(
      setCurrentLevel({ sessionId, currentLevel: 'prep' })
    ));
  };
}

export function completeLevelPreview({
  userId,
  sessionId,
  programId,
  completedLevel,
  contractId,
  funding
}) {
  return dispatch => {
    return dispatch(setActiveSession({userId, sessionId: 'none'}))
      .then(() => {
        const levelName = program.programList.filter(p => p.id === programId)[0]["levels"][completedLevel]["levelName"];
        publishEvent('Level Preview Completed', {
          userId,
          sessionId,
          programId,
          level: completedLevel,
          levelName,
          funding,
          contractId
        });
      });
  }
}



// WEBPACK FOOTER //
// ./src/actions/activeSessionActions.js